"use client";

import { c as _c } from "react/compiler-runtime";
import { Textarea } from "@navikt/ds-react";
import { logAnalyticsEvent } from "@/common/analytics/logAnalyticsEvent";
import { TEXT_FIELD_MAX_LENGTH } from "@/common/app-config";
import { useFieldContext } from "../hooks/form-context";
interface Props {
  label: string;
  description?: React.ReactNode;
  minRows?: number;
  maxLength?: number;
  isRequired: boolean;
  isChangeDisabled?: boolean;
  isReadOnly?: boolean;
}
export default function FormTextArea(t0) {
  const $ = _c(23);
  const {
    label,
    description,
    minRows,
    maxLength: t1,
    isRequired,
    isChangeDisabled: t2,
    isReadOnly: t3
  } = t0;
  const maxLength = t1 === undefined ? TEXT_FIELD_MAX_LENGTH : t1;
  const isChangeDisabled = t2 === undefined ? false : t2;
  const isReadOnly = t3 === undefined ? false : t3;
  const field = useFieldContext();
  let t4;
  if ($[0] !== field.state.meta.errors) {
    t4 = field.state.meta.errors.map(_temp).join(", ");
    $[0] = field.state.meta.errors;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const errorMessages = t4;
  let t5;
  if ($[2] !== field.state.value.length || $[3] !== label) {
    t5 = function logAnalyticsTextareaUtfylt() {
      logAnalyticsEvent({
        name: "textarea utfylt",
        properties: {
          feltNavn: label,
          harVerdi: field.state.value.length > 0,
          tegnlengde: field.state.value.length
        }
      });
    };
    $[2] = field.state.value.length;
    $[3] = label;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const logAnalyticsTextareaUtfylt = t5;
  const t6 = minRows ?? 4;
  let t7;
  if ($[5] !== field || $[6] !== isChangeDisabled) {
    t7 = e => !isChangeDisabled ? field.handleChange(e.target.value) : null;
    $[5] = field;
    $[6] = isChangeDisabled;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== field || $[9] !== logAnalyticsTextareaUtfylt) {
    t8 = () => {
      logAnalyticsTextareaUtfylt();
      field.handleBlur();
    };
    $[8] = field;
    $[9] = logAnalyticsTextareaUtfylt;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== description || $[12] !== errorMessages || $[13] !== field.name || $[14] !== field.state.value || $[15] !== isReadOnly || $[16] !== isRequired || $[17] !== label || $[18] !== maxLength || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <Textarea id={field.name} label={label} description={description} minRows={t6} resize="vertical" maxLength={maxLength} value={field.state.value} error={errorMessages} onChange={t7} onBlur={t8} readOnly={isReadOnly} aria-required={isRequired} className="mb-6" />;
    $[11] = description;
    $[12] = errorMessages;
    $[13] = field.name;
    $[14] = field.state.value;
    $[15] = isReadOnly;
    $[16] = isRequired;
    $[17] = label;
    $[18] = maxLength;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp(err) {
  return err?.message;
}